import { useTLang } from 'intl/intl';

export function useItemOutOfStockDateLang() {
  return {
    shutdownDate: {
      label: useTLang({ id: 'menuPage.outOfStock.card.date.from' }),
    },
    activationDate: {
      label: useTLang({ id: 'menuPage.outOfStock.card.date.to' }),
    },
    indefinite: useTLang({ id: 'menuPage.outOfStock.card.date.indefinite' }),
  };
}
